<template>
  <div class="relative w-full">
    <!-- Botão do Select -->
    <button
      @click="isOpen = !isOpen"
      class="w-full flex justify-between items-center px-4 h-8 text-xs bg-white border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-green-500 focus:outline-none"
    >
      {{ selectedOption ? selectedOption.label : placeholder }}
      <span class="ml-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5 transform transition-transform duration-200"
          :class="{ 'rotate-180': isOpen }"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clip-rule="evenodd"
          />
        </svg>
      </span>
    </button>

    <!-- Lista de opções -->
    <div
      v-if="isOpen"
      class="absolute mt-2 w-full bg-white border border-gray-300 rounded-md shadow-lg z-10"
    >
      <ul class="max-h-48 overflow-y-auto">
        <li
          v-for="option in options"
          :key="option.value"
          @click="selectOption(option)"
          class="px-4 py-2 cursor-pointer hover:bg-green-500 hover:text-white transition-colors text-xs"
        >
          {{ option.label }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      options: {
        type: Array,
        required: true,
      },
      placeholder: {
        type: String,
        default: "Selecione uma opção",
      },
      selected: {},
    },
    data() {
      return {
        isOpen: false,
        selectedOption: null,
      }
    },
    watch: {
      selected: {
        immediate: true,
        handler(newVal) {
          if (newVal !== null && newVal !== undefined) {
            this.selectedOption =
              this.options.find((o) => o.value === newVal) || null
          } else {
            this.selectedOption = null
          }
        },
      },
    },
    methods: {
      selectOption(option) {
        this.selectedOption = option
        this.isOpen = false
        this.$emit("update:selected", option.value)
      },
    },
  }
</script>
